import _get from './get'

const getCurrentPaymentMethodTextByPurchase = (purchase) => {
    const {paymentPlanPaymentMethod, cardLast4Digits = "", updateDebitCard} = purchase;
    const unifiedPaymentMethod = updateDebitCard ? 'DEBIT' : paymentPlanPaymentMethod
    const unifiedLast4Digits = _get(updateDebitCard, ['cardNumber'], cardLast4Digits).substr(-4)
    
    switch (unifiedPaymentMethod) {
      case 'DEBIT':
        return `Debit card ending in ${unifiedLast4Digits}`
      case 'RCC':
        return `Account ending in ${unifiedLast4Digits}`
      case 'MAIL_PROVIDER':
        return 'Mail'
    }
  }

  export default getCurrentPaymentMethodTextByPurchase;


// WEBPACK FOOTER //
// ./src/utils/getCurrentPaymentMethodTextByPurchase.js